module.exports = __webpack_public_path__ + "img/3x.2a3399a.jpg";